/**
 * This service is used to confirm the registration of the user.
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseService } from '../../../core/services/base.service';
import { ApiResult } from '../../../shared/types/api-result.types';

@Injectable({
    providedIn: 'root',
})
export class RegistrationConfirmationService extends BaseService {
    constructor(private httpClient: HttpClient) {
        super();
    }

    /**
     * Confirm the registration of the user.
     * @param dto a dto containing the temporary token and the user id
     */
    confirmRegistration(dto: ConfirmUserDto): Observable<ApiResult<string>> {
        return this.httpClient
            .post<ApiResult<string>>(`${environment.apiUrl}/auth/confirm`, dto)
            .pipe(catchError(this.handleError));
    }

    /**
     * Request a new confirmation token for the user.
     * @param dto a dto containing the user id or email
     */
    resendConfirmationEmail(dto: ResendConfirmDto): Observable<ApiResult<void>> {
        return this.httpClient
            .post<ApiResult<void>>(`${environment.apiUrl}/auth/confirm/resend`, dto)
            .pipe(catchError(this.handleError));
    }
}

export interface ConfirmUserDto {
    token: string;
    userId: string;
}

export interface ResendConfirmDto {
    userId?: string;
    email?: string;
}
